__webpack_require__.p = "/twittercloneapp/";